import React from 'react'

import Navbar from './components/Navbar'
import Hero from './components/Hero'
import texi from "./images/taxis logo black.png"
import About from './components/About'
import Services from './components/Services'
import TaxiRates from './components/TaxiRates'
import ContactForm from './components/ContactForm'
import Footer from './components/Footer'
import Check1 from './components/Check1'



const App = () => {
  return (
    <>
    {/* <Check1/> */}
    <div className='relative w-full'>
      <div>

    <Navbar/>
      </div>
      <div className='w-[60%] mx-[350px] h-[10vh] bg-white absolute z-50 mt-[-20px] rounded-xl max-[768px]:hidden max-[1108px]:h-[8vh]'>
        
       <div className='flex items-center px-10 list-none gap-x-7 justify-between'>
        <div>

          <img src={texi} className='h-[80px]'/>
        </div>
        <div className='flex gap-x-5'>
        <li className=''>
           <a href='#home' className='hover:text-blue-500 text-xl'> Home</a>
            </li>
          <li>
          <a href="#services" className="hover:text-blue-500 text-xl">Services</a>
            </li>
          <li>
          <a href="#fleet" className="hover:text-blue-500 text-xl">Fleet</a>
          </li>
          {/* <li>
          <a href="#offers" className="hover:text-blue-500">Special Offers</a>
          </li> */}
          <li>
          <a href="#contact" className="hover:text-blue-500 text-xl">Contact</a>
          </li>
        </div>
          
       </div>
      </div>
    <div id='home' className='max-[1120px]:'>

    <Hero/>
    </div>
    </div>
    <div>
      <div id="about">

      <About/>
      </div>
      <div id="services">

      <Services/>
      </div>
      <div id="fleet">

      <TaxiRates />
      </div>
      <div id="contact">

      <ContactForm/>
      </div>
      <Footer/>
    </div>
    </>
    
    
  )
}

export default App